(function() {

  var linkFunction = function($scope, element, attrs) {
    // console.log("Account Balance Widget Info Link Func: ", $scope, element, attrs);
  }

  var controllerFunction = function($scope, UserSession,webAnalytics,commonFunctionality) {
    // console.log("Account Balance Widget Info Controller Func: ", $scope);
    var utagObj={
      page_name: 'account balance',
      page_category: 'my account',
      scenario_name: 'reg:OLP',
      scenario_step: 'balance'
    };
    setTimeout(function(){webAnalytics.webTrendsUtag("OBJ",utagObj,undefined,"accountBalance"); }, 3000);

    if(cvsUtility.componentName() && cvsUtility.componentName()=="RFR" ){
      //  Initialize the UserSession service
      UserSession.init(false,"RFR");
      $scope.session = UserSession;
      $scope.content=wcmContent;
      $scope.errorMessage = {
        alertType:"error",
        title: "",
        message: "<strong>We're sorry.</strong><br>There was an error processing your request. Please try again, or connect to our technical support team from our ",
        suppressIcon: false,
        contactlink: "Contact Us"
      };
      $scope.pendingPaymentAlertConfig = {
        alertType:"info",
        title: "",
        message: "Until any pending payments are processed, we can't accept additional payments or help you set up automatic payments.",
        suppressIcon: false
      }
    }
    $scope.makePayment = function(){
      window.top.location = createChannelUrl('makePayment');
    };
    $scope.viewHistory = function(){
      window.top.location = createChannelUrl('paymentHistory');
    };
    $scope.showAutoPay = function(){
      if((UserSession.accountData.currentBalance === 0 || (UserSession.accountData.currentBalance !== 0)) &&  UserSession.accountData.activeMop){
        UserSession.autoPay.enabled=true;
        UserSession.paymentMethod=UserSession.accountData.activeMop.paymentMethodId;
        //UserSession.paymentMopType = UserSession.accountData.getMopById(UserSession.paymentMethod).payment.method;
        UserSession.autoPay.schedule=UserSession.accountData.activeMop.payment.frequency && UserSession.accountData.activeMop.payment.frequency=="IMMEDIATE"?0:UserSession.accountData.activeMop.payment.frequency;
        UserSession.reviewPageAutoPay.limit=UserSession.accountData.activeMop.payment.amount;
        //_paymentType="auto";*/
        return true;
      }else if(UserSession.accountData.currentBalance === 0){
        UserSession.autoPay.enabled=false;
        return true
      }
      return false;
      //return UserSession.accountData.currentBalance === 0 || (UserSession.accountData.currentBalance !== 0 && UserSession.autoPay.enabled === true);
    };
    $scope.$on('SERVER-ERROR', function(event, args) {
      $scope.SERVER_ERROR = true;
      // do what you want to do
    });


    $scope.renewAch =function(){
      commonFunctionality.renewACH();
    };

    $scope.disableAutopay = function() {
      commonFunctionality.disableAutoPay();
    };
  }

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/widgets/accountBalanceWidget/accountBalanceWidget.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope", "userSession","webAnalytics","commonFunctionality"];
  angular.module('cvsApp').directive('accountBalanceWidget', directiveFunction);

})();
